import { Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  selector: 'tc-test-page-component-wrapper',
  templateUrl: './component-wrapper.component.html',
  styleUrls: ['./component-wrapper.component.scss']
})
export class TestPageComponentWrapper {
  @Input() name: string;
  @Input() description: string;
  @Input() componentId: string;
  @Input() isExpanded = false;
  @Input() showExpanding = true;
}
